interface Scripts {
    name: string;
    src: string;
}  
export const ScriptStore: Scripts[] = [
    {name: 'gtm', src: '../../assets/external_scripts/gtm.js'}
];